const mensaje = document.getElementById('mensaje');
const contador = document.getElementById('contador');

if(mensaje) {
    mensaje.addEventListener('input', function(e) {
        const target = e.target;
        const longitudMax = target.getAttribute('maxlength');
        const longitudAct = target.value.length;
        contador.innerHTML = `${longitudAct}/${longitudMax}`;
    });
}

var contadorPuntualidad;
calificarPuntualidad = function(item){
    contadorPuntualidad = item.id[0];
    let nombrePuntualidad = item.id.substring(1);
    for(let a = 0;a < 5; a++) {
        if(a < contadorPuntualidad) {
            document.getElementById((a+1) + nombrePuntualidad).className="star-active cursor";
        } else {
            document.getElementById((a+1) + nombrePuntualidad).className="star-inactive cursor";
        }
        //console.log(contadorPuntualidad);
        $("input[name='puntualidad']").val(contadorPuntualidad);
    }
}
var contadorCalidad;
calificarCalidad = function(item){
    contadorCalidad = item.id[0];
    let nombreCalidad = item.id.substring(1);
    for(let b = 0;b < 5; b++) {
        if(b < contadorCalidad) {
            document.getElementById((b+1) + nombreCalidad).className="star-active cursor";
        } else {
            document.getElementById((b+1) + nombreCalidad).className="star-inactive cursor";
        }
        //console.log(contadorCalidad);
        $("input[name='calidad_servicio']").val(contadorCalidad);
    }
}
var contadorProbabilidad;
calificarProbabilidad = function(item){
    contadorProbabilidad = item.id[0];
    let nombreProbabilidad = item.id.substring(1);
    for(let c = 0;c < 5; c++) {
        if(c < contadorProbabilidad) {
            document.getElementById((c+1) + nombreProbabilidad).className="star-active cursor";
        } else {
            document.getElementById((c+1) + nombreProbabilidad).className="star-inactive cursor";
        }
        //console.log(contadorProbabilidad);
        $("input[name='probabilidad_recomendarlo']").val(contadorProbabilidad);
    }
}
var contadorPrecio;
calificarPrecio = function(item){
    contadorPrecio = item.id[0];
    let nombrePrecio = item.id.substring(1);
    for(let d = 0;d < 5; d++) {
        if(d < contadorPrecio) {
            document.getElementById((d+1) + nombrePrecio).className="star-active cursor";
        } else {
            document.getElementById((d+1) + nombrePrecio).className="star-inactive cursor";
        }
        //console.log(contadorPrecio);
        $("input[name='precio']").val(contadorPrecio);
    }
}